import React from "react";
import "./ConsultDocuments.css";
import { ArrowRight } from "lucide-react"; // ícone moderno
import Title from "../styled-components/Title";
import ButtonZap from "../components/ButtonZap";
import BackToTop from "./BackToTop";

function ConsultDocuments() {
  return (
    <div className="ConsultDocuments">
      <main>
        <div id="main-consult">
          <Title>Consulte seus documentos</Title>

          <p className="subtitle">
            Acesse o portal da <strong>CEDOC</strong> e visualize seus arquivos com
            segurança e rapidez.
          </p>

          <div className="consult-card">
            <div className="consult-info">
              <h2>Área de Consulta</h2>
              <p>
                Tenha acesso direto aos documentos digitalizados, faça
                consultas, downloads e acompanhe o status dos seus arquivos em
                tempo real pelo nosso portal seguro.
              </p>

              <a
                href="https://fd.cedoc.net.br/FileDirector/Web/authorization/login?ReturnUrl=%2fFileDirector%2fWeb"
                target="_blank"
                rel="noreferrer noopener"
                className="consult-btn"
              >
                Acessar o portal <ArrowRight size={20} />
              </a>
            </div>

            <div className="consult-illustration">
              <img
                src="https://cdn-icons-png.flaticon.com/512/5521/5521342.png"
                alt="Consulta de documentos"
              />
            </div>
          </div>
        </div>
      </main>

      <ButtonZap />
      <BackToTop />
    </div>
  );
}

export default ConsultDocuments;
